// extracted by mini-css-extract-plugin
module.exports = {"dragAndDrop":"drag_and_drop_dragAndDrop__BRqeb","dragging":"drag_and_drop_dragging__5i9cG"};